(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1033],{

/***/ 47246:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator/tiles-dealer/[storeId]",
      function () {
        return __webpack_require__(61330);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_stars__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40765);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83346);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63372);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52681);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);















function StoreId(param) {
    let { placeDetails , cpDetails  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [isCanonicalNeeded, setIsCanonicalNeeded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [timeDropDown, setTimeDropDown] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { storeId  } = router.query; //storeId here is google_place_id
    const [storeDetails, setStoreDetails] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(placeDetails === null || placeDetails === void 0 ? void 0 : placeDetails.result);
    const [isOpenNow, setIsOpenNow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [closingTime, setClosingTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [weeklySchedule, setWeeklySchedule] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [gmapId, setGmapId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(placeDetails === null || placeDetails === void 0 ? void 0 : (ref = placeDetails.result) === null || ref === void 0 ? void 0 : ref.place_id);
    const [cpCode, setCpCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((cpDetails === null || cpDetails === void 0 ? void 0 : (ref1 = cpDetails.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getNonObtbsByCpCode) === null || ref2 === void 0 ? void 0 : ref2.no) ? cpDetails === null || cpDetails === void 0 ? void 0 : (ref3 = cpDetails.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.getNonObtbsByCpCode) === null || ref4 === void 0 ? void 0 : ref4.no : "");
    const [storeCity, setStoreCity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((ref7 = placeDetails === null || placeDetails === void 0 ? void 0 : (ref5 = placeDetails.result) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.address_components) === null || ref6 === void 0 ? void 0 : ref6.find((s)=>s.types.includes("administrative_area_level_3"))) === null || ref7 === void 0 ? void 0 : ref7.long_name) || "");
    const [storeState, setStoreState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((ref10 = placeDetails === null || placeDetails === void 0 ? void 0 : (ref8 = placeDetails.result) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.address_components) === null || ref9 === void 0 ? void 0 : ref9.find((s)=>s.types.includes("administrative_area_level_1"))) === null || ref10 === void 0 ? void 0 : ref10.long_name) || "");
    const [businessHours, setBusinessHours] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(placeDetails === null || placeDetails === void 0 ? void 0 : (ref11 = placeDetails.result) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.opening_hours) === null || ref12 === void 0 ? void 0 : ref12.weekday_text);
    const [nonObtStorebDetail, setNonObtbStoreDetail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(cpDetails === null || cpDetails === void 0 ? void 0 : (ref13 = cpDetails.data) === null || ref13 === void 0 ? void 0 : ref13.getNonObtbsByCpCode);
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [getInTouch, setGetInTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [displayInstaReel, setDisplayInstaReel] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [reelSrc, setReelSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const videoLinks = [
        {
            key: "bath-selection-and-tiles",
            src: "https://www.instagram.com/reel/DE9TcU9y_mA/embed/"
        }
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!router.isReady) return; // Ensure router is ready before accessing asPath
        let endpoint = router.asPath.split("/").pop(); // Get last segment of URL
        let arr = videoLinks.filter((i)=>i.key === endpoint);
        if (arr.length > 0) {
            setDisplayInstaReel(true);
            setReelSrc(arr[0].src);
        }
    }, [
        router.isReady,
        router.asPath
    ]); // Dependency added to trigger when route changes
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const now = new Date();
        const indiaTime = new Date(now.toLocaleString("en-US", {
            timeZone: "Asia/Kolkata"
        }));
        const hours = indiaTime.getHours(); // Get hours in IST
        setIsOpen(hours < 18); // Open if before 6 PM IST
        getRelatedBlogs();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        const now = new Date();
        const currentDay = now.getDay(); // 0 for Sunday, 1 for Monday, etc.
        const currentTime = now.getHours() * 100 + now.getMinutes(); // e.g., 1330 for 1:30 PM
        const todaySchedule = storeDetails === null || storeDetails === void 0 ? void 0 : (ref = storeDetails.opening_hours) === null || ref === void 0 ? void 0 : (ref1 = ref.periods) === null || ref1 === void 0 ? void 0 : ref1.find((period)=>period.open.day === currentDay);
        if (todaySchedule) {
            const openingTime = parseInt(todaySchedule.open.time, 10);
            const closingTime = parseInt(todaySchedule.close.time, 10);
            if (currentTime >= openingTime && currentTime < closingTime) {
                setIsOpenNow(true);
                setClosingTime(formatTime(todaySchedule.close.time));
            } else {
                setIsOpenNow(false);
            }
        }
        const schedule = storeDetails === null || storeDetails === void 0 ? void 0 : (ref2 = storeDetails.opening_hours) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.periods) === null || ref3 === void 0 ? void 0 : ref3.map((period)=>({
                day: getDayName(period.open.day),
                open: formatTime(period.open.time),
                close: formatTime(period.close.time)
            }));
        setWeeklySchedule(schedule);
    }, [
        router.query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // Set canonical tag only if storeId and cpCode are missing
        if (!storeId && !cpCode) {
            setIsCanonicalNeeded(true);
        }
    }, [
        storeId,
        cpCode
    ]);
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (pin && String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_7__/* .getIntouch */ .JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                swal(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                swal(response.data.get_in_touch.msg);
                setGetInTouch(false);
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
            }
        }
    };
    var requestOptions = {
        method: "GET"
    };
    const getRelatedBlogs = async ()=>{
        // try{
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=tiles"), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
    };
    const settings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: false,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    };
    const handleTimeDropDown = async ()=>{
        timeDropDown == true ? setTimeDropDown(false) : setTimeDropDown(true);
    };
    const formatTime = (time)=>{
        const hour = parseInt(time.substring(0, 2), 10);
        const minute = time.substring(2);
        const date = new Date();
        date.setHours(hour);
        date.setMinutes(minute);
        return date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    const getDayName = (dayIndex)=>{
        const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        return days[dayIndex];
    };
    const redirectToGoogleMaps = (lat, lng)=>{
        const googleMapsUrl = "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
        window.open(googleMapsUrl, "_blank");
    };
    const Responsive = ()=>{
        const settings = {
            infinite: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            autoplay: true,
            centerMode: false,
            autoplaySpeed: 3000,
            arrows: true,
            dots: false,
            centerPadding: "0px",
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        slidesToShow: 3
                    }
                }
            ]
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "menu-slider store-locator-page",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        charSet: "UTF-8",
                        href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        ...settings,
                        className: "category-menu",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/floor-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/FLOOR TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Floor Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/wall-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/WALL TILES.jpg",
                                                loading: "lazy",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Wall Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/bathroom-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/BATHROOM TILES.jpg",
                                                loading: "lazy",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Bathroom Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/kitchen-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/KITCHEN TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Kitchen Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/living-room-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/new-room-tiles.webp",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Room Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/marble-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/MARBLE TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Marble Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/wooden-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/WOODEN TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Wooden Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/vitrified-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/VITRIFIED TILE.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Vitrified Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/ceramic-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/CERAMIC TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Ceramic Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/cool-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/COOL TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Cool Tiles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.orientbell.com/tiles/large-tiles-tiles",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/LARGE TILES.jpg",
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Large Tiles"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Visit ".concat(!nonObtStorebDetail ? "".concat(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name, " in ").concat(storeCity) : "".concat(nonObtStorebDetail.name, " in ").concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.city), ". Extensive range of wall & floor tiles. Get expert advice and see the range of Orientbell Tiles. Visit our showroom today!")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            !nonObtStorebDetail ? "".concat(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name, " - ").concat(storeCity, ", ").concat(storeState) : "".concat(nonObtStorebDetail.name, " - ").concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.city, ", ").concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.state_desc),
                            "| Quality Floor & Wall Tiles"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "".concat(!nonObtStorebDetail ? "".concat(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name, " - ").concat(storeCity, ", ").concat(storeState) : "".concat(nonObtStorebDetail.name, " - ").concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.city, ", ").concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.state_desc), " | Quality Floor & Wall Tiles")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "obl-store-page",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "obl-store-intro-section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            href: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            href: "/store-locator",
                                            children: "Store Locator"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            href: "/store-locator/tiles-dealer/".concat((ref14 = !nonObtStorebDetail ? storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name : nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.name) === null || ref14 === void 0 ? void 0 : ref14.toLowerCase().replace(/\s+/g, "-")),
                                            children: !nonObtStorebDetail ? storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name : nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "obl-store-intro-row",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "obl-store-intro-left",
                                            children: [
                                                !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    children: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                    children: [
                                                        "Orientbell Tiles Dealer - ",
                                                        nonObtStorebDetail.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    className: "info-group",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/business-i.png"
                                                                    })
                                                                }),
                                                                !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-text",
                                                                    children: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name.split("-")[1]
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "info-text",
                                                                    children: [
                                                                        " ",
                                                                        nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.name
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/ss-i.png"
                                                                    })
                                                                }),
                                                                !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-text",
                                                                    children: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.formatted_address
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "info-text",
                                                                        children: nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.address
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/s-phone-i.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-text",
                                                                    children: !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "tel:".concat(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.formatted_phone_number),
                                                                        children: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.formatted_phone_number
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "tel:".concat(nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.phone_no),
                                                                        children: nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.phone_no
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: timeDropDown ? "store-clock active" : "store-clock",
                                                            onClick: handleTimeDropDown,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/s-clock-i.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "info-text",
                                                                    children: [
                                                                        isOpenNow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "arrow-btn",
                                                                                    children: [
                                                                                        "Open until ",
                                                                                        closingTime
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                    children: "Open Now"
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                            children: "Closed Now"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                            className: "dropdown-list",
                                                                            children: weeklySchedule === null || weeklySchedule === void 0 ? void 0 : weeklySchedule.map((schedule, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            className: "first-text",
                                                                                            children: schedule.day
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                            className: "info-text",
                                                                                            children: [
                                                                                                schedule.open,
                                                                                                " - ",
                                                                                                schedule.close
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: timeDropDown ? "store-clock active" : "store-clock",
                                                            onClick: handleTimeDropDown,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "info-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/s-clock-i.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "info-text",
                                                                    children: [
                                                                        isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "arrow-btn",
                                                                                    children: "Open until 6:00 PM"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                    children: "Open Now"
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "arrow-btn closed",
                                                                            children: "Closed"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                            class: "dropdown-list",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Monday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Tuesday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Wednesday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Thursday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Friday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "first-text",
                                                                                            children: "Saturday"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            class: "info-text",
                                                                                            children: "10:00 AM - 6:00 PM"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "obl-store-intro-right",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "#",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "/store-loc-ban.jpg"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "store-feature-product-section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    children: [
                                        "Featured Products in ",
                                        storeCity,
                                        ", ",
                                        storeState
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    children: [
                                        "Featured Products in ",
                                        nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.city,
                                        ",",
                                        " ",
                                        nonObtStorebDetail === null || nonObtStorebDetail === void 0 ? void 0 : nonObtStorebDetail.state_desc
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "store-feature-product-row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        ...settings,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-pro-slid-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store-pro-img",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "https://images.orientbell.com/media/catalog/product/n/a/nano_ivory_1.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store-pro-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                children: "Nano Ivory (P)"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: ()=>setGetInTouch(true),
                                                                className: "buynow-btn",
                                                                children: "Know More"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-pro-slid-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store-pro-img",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "https://images.orientbell.com/media/catalog/product/o/d/odg-alberta-beige.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store-pro-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                children: "ODG Alberta Beige"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: ()=>setGetInTouch(true),
                                                                className: "buynow-btn",
                                                                children: "Know More"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-pro-slid-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store-pro-img",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "https://images.orientbell.com/media/catalog/product/o/h/ohg_line_travertine_brown_hl_odg_travertine_brown_lt_dk_300x450_mm_1.webp",
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store-pro-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                children: "ODG Travertine Brown LT"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: ()=>setGetInTouch(true),
                                                                className: "buynow-btn",
                                                                children: "Know More"
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-pro-slid-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store-pro-img",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "https://images.orientbell.com/media/catalog/product/o/d/odg_dakota_brown_light.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store-pro-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                children: "ODG Dakota Brown Light"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: ()=>setGetInTouch(true),
                                                                className: "buynow-btn",
                                                                children: "Know More"
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-pro-slid-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store-pro-img",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "https://images.orientbell.com/media/catalog/product/c/o/cool_tile_ec_1.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store-pro-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                children: "OPV Orient EC Cool Tiles"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: ()=>setGetInTouch(true),
                                                                className: "buynow-btn",
                                                                children: "Know More"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "obl-store-reviews-section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "obl-store-about-row",
                                    children: [
                                        !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            children: [
                                                "Orientbell Tiles - Tile Store in ",
                                                storeCity,
                                                ", ",
                                                storeState
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            children: [
                                                "Orientbell Tiles - Tile Store in ",
                                                nonObtStorebDetail.city,
                                                ",",
                                                " ",
                                                nonObtStorebDetail.state_desc
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                " ",
                                                "Orientbell Tiles is one of India’s leading tile manufacturers with manufacturing plants in Sikandarabad (U.P.), Dora (Gujarat) & Hoskote (Karnataka). Orientbell Tiles was established in 1977 and since then it continues to be one of the trusted tile companies of India. The company manufacturers wall and floor tiles in ceramic, vitrified, double charge & full-body categories and it’s dealer/channel partners are spread across pan-India. In the last couple of years, the company has evolved digitally with a launch of QuickLook; as an exclusive visualization tool now available at several of its dealers and tile boutiques, Trulook, Samelook, Trailook and has also relaunched it’s website with industry-first features and world-class tools.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "The address of this dealer is Shop No 123 to 125, Samman Bazar, Jangpura, Bhogal, New Delhi, Delhi.",
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "obl-store-reviews-info",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "obl-store-reviews-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: !nonObtStorebDetail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Ratings & Reviews"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "rating-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_stars__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                        count: 5,
                                                                        value: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.rating,
                                                                        edit: false,
                                                                        size: 30,
                                                                        color2: "#ff5e00"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        children: storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.rating
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                className: "store-rating",
                                                                children: (ref16 = storeDetails === null || storeDetails === void 0 ? void 0 : (ref15 = storeDetails.reviews) === null || ref15 === void 0 ? void 0 : ref15.slice(0, 2)) === null || ref16 === void 0 ? void 0 : ref16.map((review, index)=>{
                                                                    const { author_name , time , rating , text , author_url , profile_photo_url  } = review;
                                                                    // Convert the time to a human-readable format
                                                                    const reviewDate = new Date(time * 1000).toLocaleDateString();
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                                        children: author_name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        "Posted on: ",
                                                                                        reviewDate
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    className: "rated-row",
                                                                                    children: [
                                                                                        "Rated:",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_stars__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                                            count: 5,
                                                                                            value: rating,
                                                                                            edit: false,
                                                                                            color2: "#ff5e00"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        "Review: ",
                                                                                        text
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, index);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "review-btn-section-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "review-action",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                            onClick: ()=>window.open("https://search.google.com/local/reviews?placeid=".concat(gmapId), "_blank"),
                                                                            children: "View All"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "review-action submit obl-store-actions-btn",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                            onClick: ()=>window.open("https://search.google.com/local/writereview?placeid=".concat(gmapId), "_blank"),
                                                                            children: "Submit a Review"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                businessHours ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Business Hours"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "BusinessHours-row",
                                                                children: businessHours.map((hour, index)=>{
                                                                    const [day, time] = hour.split(": "); // Split the day and the time
                                                                    const dayAbbreviation = day.slice(0, 3); // Extract the first 3 letters of the day
                                                                    const formattedTime = time ? time.trim() : "Closed";
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                        className: "BusinessHours-col",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                            className: "info-card",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "first-text",
                                                                                    children: dayAbbreviation
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: formattedTime == "Closed" ? "info-text text-danger" : "info-text",
                                                                                    children: formattedTime
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Business Hours"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                class: "BusinessHours-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                        class: "BusinessHours-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Mon"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Tue"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Wed"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Thu"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                        class: "BusinessHours-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Fri"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Sat"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                class: "info-card",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "first-text",
                                                                                        children: "Sun"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        class: "info-text ",
                                                                                        children: "10:00 AM - 6:00 PM"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "obl-store-reviews-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Other Dealers of Orientbell Tiles"
                                                            }),
                                                            !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "other-dealers-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            "Orientbell Tiles dealers in",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: "/store-locator/".concat(encodeURIComponent(storeState), "/").concat(encodeURIComponent(storeCity)),
                                                                                onClick: (e)=>{
                                                                                    var ref, ref1;
                                                                                    e.preventDefault(); // Prevent default navigation
                                                                                    localStorage.removeItem("cityFromSimpleSearch");
                                                                                    localStorage.setItem("stateFromAdvancedSearch", storeState);
                                                                                    localStorage.setItem("cityFromAdvancedSearch", storeCity);
                                                                                    window.location.href = "/store-locator/".concat((ref = encodeURIComponent(storeState)) === null || ref === void 0 ? void 0 : ref.toLowerCase().replace(/\s+/g, "-"), "/").concat((ref1 = encodeURIComponent(storeCity)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().replace(/\s+/g, "-"));
                                                                                },
                                                                                children: storeCity
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            "Orientbell Tiles dealers in",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: "/store-locator/".concat(encodeURIComponent(storeState)),
                                                                                onClick: (e)=>{
                                                                                    var ref;
                                                                                    e.preventDefault();
                                                                                    localStorage.setItem("stateFromAdvancedSearch", storeState);
                                                                                    localStorage.removeItem("cityFromAdvancedSearch");
                                                                                    localStorage.removeItem("cityFromSimpleSearch");
                                                                                    window.location.href = "/store-locator/".concat((ref = encodeURIComponent(storeState)) === null || ref === void 0 ? void 0 : ref.toLowerCase().replace(/\s+/g, "-"));
                                                                                },
                                                                                children: storeState
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "other-dealers-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            "Orientbell Tiles dealers in",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: "/store-locator/".concat(nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-"), "/").concat(nonObtStorebDetail.city.toLowerCase().replace(/\s+/g, "-")),
                                                                                onClick: (e)=>{
                                                                                    e.preventDefault();
                                                                                    localStorage.removeItem("cityFromSimpleSearch");
                                                                                    localStorage.setItem("stateFromAdvancedSearch", nonObtStorebDetail.state_desc);
                                                                                    localStorage.setItem("cityFromAdvancedSearch", nonObtStorebDetail.city);
                                                                                    window.location.href = "/store-locator/".concat(nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-"), "/").concat(nonObtStorebDetail.city.toLowerCase().replace(/\s+/g, "-"));
                                                                                },
                                                                                children: nonObtStorebDetail.city
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            "Orientbell Tiles dealers in",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: "/store-locator/".concat(nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-")),
                                                                                onClick: (e)=>{
                                                                                    e.preventDefault();
                                                                                    localStorage.setItem("stateFromAdvancedSearch", nonObtStorebDetail.state_desc);
                                                                                    localStorage.removeItem("cityFromAdvancedSearch");
                                                                                    localStorage.removeItem("cityFromSimpleSearch");
                                                                                    window.location.href = "/store-locator/".concat(nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-"));
                                                                                },
                                                                                children: nonObtStorebDetail.state_desc
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Payment Methods"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "store-service-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: "Cash"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: "Online Payment"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                !nonObtStorebDetail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "store-card-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-header",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                children: [
                                                                    "Get Direction To ",
                                                                    storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name.split("-")[1]
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "pluscode-location",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "pluscode-location-left",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "https://www.google.com/search?q=<business_name>\n".concat(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.name),
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            children: "View Business Profile"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "pluscode-location-right",
                                                                        onClick: ()=>redirectToGoogleMaps(storeDetails.geometry.location.lat, storeDetails.geometry.location.lng),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: "/s-direction-i.png",
                                                                            alt: ""
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "store-additional-content",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "Explore Our Range"
                            })
                        })
                    }),
                    Responsive(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "additional-content-section",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container",
                                children: [
                                    !nonObtStorebDetail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        children: [
                                            "Orientbell Tiles in ",
                                            storeCity,
                                            ", ",
                                            storeState
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        children: [
                                            "Orientbell Tiles in ",
                                            nonObtStorebDetail.city,
                                            ",",
                                            " ",
                                            nonObtStorebDetail.state_desc
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "store-additional-content-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Bathroom Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "Maintaining good hygiene and enjoying a refreshing hot shower or preparing for a productive day starts with a bathroom that meets your needs and reflects your personality. Orientbell Tiles offers diverse",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/bathroom-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "bathroom tile"
                                                            }),
                                                            " ",
                                                            "variants that cater to every style and budget. Our stylish bathroom wall tiles and anti-skid bathroom floor tiles are a perfect combination to provide both visual appeal and safety features for your bathroom. Be it ceramic or vitrified, each tile type is crafted to uplift any bathroom's look and usability, creating a pleasant environment for relaxation. Talking about designs, we have something for every bathroom - from classic choices like wooden and marble designs for both walls and floors to innovative wall designs like",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/dolphin-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "dolphin tiles"
                                                            }),
                                                            " ",
                                                            "to add a playful and unique touch to your bathroom walls. Our bathroom tile designs not only add aesthetic charm but also ensure lasting quality. Explore bathroom tile prices in your city that can both upgrade your bathroom beautifully and fit every budget. Choose Orientbell Tiles for your next bathroom renovation!"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Kitchen Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "The kitchen is the heart of the home, where wonderful dishes are prepared. Every kitchen is a centre of warmth and life, from family gatherings to sharing meals and stories. The key to a great kitchen is ensuring its functions as well as its looks. Orientbell Tiles offers countless design choices in",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/kitchen-wall-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "kitchen wall tiles"
                                                            }),
                                                            ", from sleek, elegant floral to charming",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/cup-plate-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "cup plate tiles"
                                                            }),
                                                            " ",
                                                            "that add a touch of personality. Focusing on both style and usability, our kitchen wall and floor tiles provide easy cleaning and are long-lasting. With a selection of choices to fit diverse preferences and budgets, you can find the perfect tiles to suit your kitchen decor. Explore our kitchen tile prices in your city to find the right option for your renovation needs. Choose Orientbell Tiles for a stylish and functional kitchen upgrade!"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Living Room Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "Any good living room would be relaxing and productive. From watching TV with family to welcoming guests, the living room is meant to feel comfortable and inviting. Orientbell Tiles offers excellent living room tile designs, designed to upgrade every living room’s visual beauty and usability. Our collection features stylish wall tiles and modern floor tiles for living rooms, blending style and elegance to suit any design preference. If you are looking for contemporary living room tiles for walls or timeless marble living room floor tiles, we have a design to suit every inspiration. Our",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/living-room-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "tiles for living rooms"
                                                            }),
                                                            " ",
                                                            "are easy to clean and maintain, ensuring your living room looks stunning and withstands daily wear. Discover our variety of living room tile designs and find the perfect match for your home. Choose Orientbell Tiles for a stylish and sensible living room upgrade!"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Large Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "Large tiles are an excellent choice for achieving seamless continuity in design. Orientbell Tiles’ range includes impressive sizes like 1200x1800mm tiles, 800x2400mm tiles, and 800x1600mm tiles, perfect for creating a sleek, modern look with fewer grout lines. These",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/large-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "large tiles"
                                                            }),
                                                            " ",
                                                            "can be used to elevate both walls and floors, creating an uninterrupted and more spacious appearance in every space. They offer robustness and ease of maintenance, making them a practical option for commercial and residential spaces like restaurants, hotels, living rooms, etc. Explore our range of large tiles to find a suitable fit for your next project, and enjoy a contemporary upgrade with Orientbell Tiles."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Elevation Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "The first impression of your home is defined by its exterior. This is where Orientbell Tiles’ elevation tiles can help you. They are crafted to deliver stunning looks to building exteriors and create engaging focal points in interiors. Our tile range includes stylish",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/elevation-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "front elevation tiles"
                                                            }),
                                                            " ",
                                                            "that are perfect for adding character and charm to any wall. If you are looking for a unique, weatherproof elevation tile design for your home’s exterior or an accent wall in your living room, our versatile tile range provides both beauty and durability. With diversity in designs and easy-to-care finishes, you can create an impressive first impression and enhance your building's exterior look. Discover our elevation tile designs to find the perfect choice for a modern interior or exterior look."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-additional-content-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: "Parking Tiles"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            "Parking tiles are a perfect choice for various outdoor spaces, including driveways, garden patios, and walkways.",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                class: "link",
                                                                href: "https://www.orientbell.com/tiles/parking-tiles",
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                children: "Orientbell Tiles’s parking or paver tile"
                                                            }),
                                                            " ",
                                                            "selection features robust parking tile design choices that withstand heavy vehicle movements and harsh weather conditions, making them perfect for parking areas, decks, and pathways. With an exclusive array of tile finishes and styles, you can enhance the functionality and look of your outdoor spaces. Choose Orientbell Tiles for reliable and attractive outdoor parking tiles."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                className: "home-color-tile-section",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "home-color-tile",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Inspiring Home Design Ideas Awaits! "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Discover unique home design ideas to elevate interiors and exteriors with style, comfort and personal touch."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "home-color-tile-row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "home-color-tile-col",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "https://www.orientbell.com/design-ideas/bathroom-designs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://www.orientbell.com/media/design_page/bathroom_desings/600x360%20Pix_0019_ODH_TABLON_BROWN_HL_ODG_TABLON_BROWN_&_ODG_TABLON_BEIGE_300x450_MM.webp",
                                                                    alt: "image"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-text",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    children: "Bathroom Design"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "home-color-tile-col",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "https://www.orientbell.com/design-ideas/kitchen-designs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://www.orientbell.com/media/design_page/kitchen_designs/600x360_Pix_0010_DR_Decor_Moroccan_DK_600x1200_mm.webp",
                                                                    alt: "image"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-text",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    children: "Kitchen Design "
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "home-color-tile-col",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "https://www.orientbell.com/design-ideas/living-room-designs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://www.orientbell.com/media/design_page/living_room_desings/600x360_Pix__0009_Dr_Gloss_Decor_Morrocan_Art_Blu_.webp",
                                                                    alt: "image"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-text",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    children: "Living Room Design "
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "home-color-tile-col",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "https://www.orientbell.com/design-ideas/bedroom-designs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://www.orientbell.com/media/design_page/bedroom_designs/600x360%20Pix_0017_CARVING_METAL_BRECCIA_MARBLE.webp",
                                                                    alt: "image"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-text",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    children: "Bedroom Design "
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "home-color-tile-col lastchild-color-bx",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "https://www.orientbell.com/design-ideas/pooja-room-designs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://www.orientbell.com/media/design_page/pooja_room_desings/600x360_Pix__0004_OHG_Rhomboid_Rhomboid_Creama_300x450mm.webp",
                                                                    alt: "image"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "find-color-text",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    children: "Pooja Room Design "
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "shop-all-solor-btn",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.orientbell.com/design-ideas",
                                                className: "default-btn shop-all-btn",
                                                children: "View All Designs"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tile-related-blog",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "title",
                                children: "Blogs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-relatedpost-row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "related-blog-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "blog-figure",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: obj.permalink,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: obj.image,
                                                            loading: "lazy",
                                                            alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "blog-text",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "listingDate",
                                                            children: obj.date
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "listingHead",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: obj.permalink,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: obj.title
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "listingText",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: obj.content.slice(0, -11)
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "listingButton",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: obj.permalink,
                                                                        children: "Read More"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        show: getInTouch,
                        className: "pincode-popup-bx expert_assistance_modal",
                        onHide: ()=>setGetInTouch(false),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Dialog */ .Z.Dialog, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Header */ .Z.Header, {
                                    closeButton: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Title */ .Z.Title, {
                                        children: "Get Tile Expert Assistance"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            submitGetInTouch();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicEmail",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Label */ .Z.Label, {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Control */ .Z.Control, {
                                                        type: "text",
                                                        placeholder: "Name*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                name: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Label */ .Z.Label, {
                                                        children: "Mobile"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Control */ .Z.Control, {
                                                        type: "number",
                                                        placeholder: "Mobile Number*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                number: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Label */ .Z.Label, {
                                                        children: "Pincode"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Control */ .Z.Control, {
                                                        type: "number",
                                                        placeholder: "Pincode",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                pincode: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "error text-danger",
                                                children: touch.error
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                variant: "primary",
                                                type: "submit",
                                                disabled: touch.loading,
                                                style: {
                                                    width: "100%"
                                                },
                                                children: touch.loading ? "Submitting" : "Submit"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (StoreId);


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ }),

/***/ 40765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var parentStyles = {
  overflow: 'hidden',
  position: 'relative'
};

var defaultStyles = {
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  display: 'block',
  float: 'left'
};

var getHalfStarStyles = function getHalfStarStyles(color, uniqueness) {
  return '\n    .react-stars-' + uniqueness + ':before {\n      position: absolute;\n      overflow: hidden;\n      display: block;\n      z-index: 1;\n      top: 0; left: 0;\n      width: 50%;\n      content: attr(data-forhalf);\n      color: ' + color + ';\n  }';
};

var ReactStars = function (_Component) {
  _inherits(ReactStars, _Component);

  function ReactStars(props) {
    _classCallCheck(this, ReactStars);

    // set defaults

    var _this = _possibleConstructorReturn(this, (ReactStars.__proto__ || Object.getPrototypeOf(ReactStars)).call(this, props));

    props = _extends({}, props);

    _this.state = {
      uniqueness: (Math.random() + '').replace('.', ''),
      value: props.value || 0,
      stars: [],
      halfStar: {
        at: Math.floor(props.value),
        hidden: props.half && props.value % 1 < 0.5
      }
    };

    _this.state.config = {
      count: props.count,
      size: props.size,
      char: props.char,
      // default color of inactive star
      color1: props.color1,
      // color of an active star
      color2: props.color2,
      half: props.half,
      edit: props.edit
    };

    return _this;
  }

  _createClass(ReactStars, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        stars: this.getStars(this.state.value)
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        stars: this.getStars(props.value),
        value: props.value,
        halfStar: {
          at: Math.floor(props.value),
          hidden: this.state.config.half && props.value % 1 < 0.5
        }
      });
    }
  }, {
    key: 'isDecimal',
    value: function isDecimal(value) {
      return value % 1 !== 0;
    }
  }, {
    key: 'getRate',
    value: function getRate() {
      var stars = void 0;
      if (this.state.config.half) {
        stars = Math.floor(this.state.value);
      } else {
        stars = Math.round(this.state.value);
      }
      return stars;
    }
  }, {
    key: 'getStars',
    value: function getStars(activeCount) {
      if (typeof activeCount === 'undefined') {
        activeCount = this.getRate();
      }
      var stars = [];
      for (var i = 0; i < this.state.config.count; i++) {
        stars.push({
          active: i <= activeCount - 1
        });
      }
      return stars;
    }
  }, {
    key: 'mouseOver',
    value: function mouseOver(event) {
      var _state = this.state,
          config = _state.config,
          halfStar = _state.halfStar;

      if (!config.edit) return;
      var index = Number(event.target.getAttribute('data-index'));
      if (config.half) {
        var isAtHalf = this.moreThanHalf(event, config.size);
        halfStar.hidden = isAtHalf;
        if (isAtHalf) index = index + 1;
        halfStar.at = index;
      } else {
        index = index + 1;
      }
      this.setState({
        stars: this.getStars(index)
      });
    }
  }, {
    key: 'moreThanHalf',
    value: function moreThanHalf(event, size) {
      var target = event.target;

      var mouseAt = event.clientX - target.getBoundingClientRect().left;
      mouseAt = Math.round(Math.abs(mouseAt));
      return mouseAt > size / 2;
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave() {
      var _state2 = this.state,
          value = _state2.value,
          halfStar = _state2.halfStar,
          config = _state2.config;

      if (!config.edit) return;
      if (config.half) {
        halfStar.hidden = !this.isDecimal(value);
        halfStar.at = Math.floor(this.state.value);
      }
      this.setState({
        stars: this.getStars()
      });
    }
  }, {
    key: 'clicked',
    value: function clicked(event) {
      var _state3 = this.state,
          config = _state3.config,
          halfStar = _state3.halfStar;

      if (!config.edit) return;
      var index = Number(event.target.getAttribute('data-index'));
      var value = void 0;
      if (config.half) {
        var isAtHalf = this.moreThanHalf(event, config.size);
        halfStar.hidden = isAtHalf;
        if (isAtHalf) index = index + 1;
        value = isAtHalf ? index : index + .5;
        halfStar.at = index;
      } else {
        value = index = index + 1;
      }
      this.setState({
        value: value,
        stars: this.getStars(index)
      });
      this.props.onChange(value);
    }
  }, {
    key: 'renderHalfStarStyleElement',
    value: function renderHalfStarStyleElement() {
      var _state4 = this.state,
          config = _state4.config,
          uniqueness = _state4.uniqueness;

      return _react2.default.createElement('style', { dangerouslySetInnerHTML: {
          __html: getHalfStarStyles(config.color2, uniqueness)
        } });
    }
  }, {
    key: 'renderStars',
    value: function renderStars() {
      var _this2 = this;

      var _state5 = this.state,
          halfStar = _state5.halfStar,
          stars = _state5.stars,
          uniqueness = _state5.uniqueness,
          config = _state5.config;
      var color1 = config.color1,
          color2 = config.color2,
          size = config.size,
          char = config.char,
          half = config.half,
          edit = config.edit;

      return stars.map(function (star, i) {
        var starClass = '';
        if (half && !halfStar.hidden && halfStar.at === i) {
          starClass = 'react-stars-' + uniqueness;
        }
        var style = _extends({}, defaultStyles, {
          color: star.active ? color2 : color1,
          cursor: edit ? 'pointer' : 'default',
          fontSize: size + 'px'
        });
        return _react2.default.createElement(
          'span',
          {
            className: starClass,
            style: style,
            key: i,
            'data-index': i,
            'data-forhalf': char,
            onMouseOver: _this2.mouseOver.bind(_this2),
            onMouseMove: _this2.mouseOver.bind(_this2),
            onMouseLeave: _this2.mouseLeave.bind(_this2),
            onClick: _this2.clicked.bind(_this2) },
          char
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement(
        'div',
        { className: className, style: parentStyles },
        this.state.config.half ? this.renderHalfStarStyleElement() : '',
        this.renderStars()
      );
    }
  }]);

  return ReactStars;
}(_react.Component);

ReactStars.propTypes = {
  className: _propTypes2.default.string,
  edit: _propTypes2.default.bool,
  half: _propTypes2.default.bool,
  value: _propTypes2.default.number,
  count: _propTypes2.default.number,
  char: _propTypes2.default.string,
  size: _propTypes2.default.number,
  color1: _propTypes2.default.string,
  color2: _propTypes2.default.string
};

ReactStars.defaultProps = {
  edit: true,
  half: true,
  value: 0,
  count: 5,
  char: '★',
  size: 15,
  color1: 'gray',
  color2: '#ffd700',

  onChange: function onChange() {}
};

exports.Z = ReactStars;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7767,7361,5518,4585,7615,6212,2770,3372,9774,2888,179], function() { return __webpack_exec__(47246); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);